import type { ModelConfig } from '../../services/api';

interface BackgroundSelectorProps {
  value: boolean;
  onChange: (value: boolean) => void;
  model?: ModelConfig;
}

const OPTIONS = [
  { value: false, label: '不透明' },
  { value: true, label: '透明' },
];

export function BackgroundSelector({ value, onChange, model }: BackgroundSelectorProps) {
  // 仅在模型显式开启透明背景能力时显示
  if (model?.enableTransparentBackground !== true) {
    return null;
  }

  return (
    <div>
      <label className="text-sm font-medium text-light-text mb-3 block">背景（透明背景输出 PNG）</label>
      <div className="flex gap-2">
        {OPTIONS.map((option) => (
          <button
            key={String(option.value)}
            onClick={() => onChange(option.value)}
            data-active={value === option.value}
            className="quality-btn flex-1"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
